import produce from 'immer'
import { PromptStepSchema } from '@feedyou-ai/feedbot-schema'

import { UnsetDialogsService } from '../../../types'

export const unsetDialogs: UnsetDialogsService<PromptStepSchema> = (dialogIds, step) => {
  return produce(step, result => {
    result.answers?.forEach(answer => {
      if (dialogIds.includes(answer.dialog as any)) {
        answer.dialog = undefined
      }
    })

    if (dialogIds.includes(result.defaultAnswer?.dialog as any)) {
      result.defaultAnswer!.dialog = undefined
    }

    if (dialogIds.includes(result.validator?.validDialog)) {
      result.validator!.validDialog = undefined
    }

    if (dialogIds.includes(result.validator?.invalidDialog)) {
      result.validator!.invalidDialog = undefined
    }
  })
}
